import {
  Box,
  Button,
  Center,
  Flex,
  Image,
  Img,
  Link,
  Skeleton,
  Text,
  useBreakpointValue
} from "@chakra-ui/react";
import { MdDoubleArrow, MdOutlineDoubleArrow } from "react-icons/md";
import Slider from "react-slick";

import { Rating } from "@/components/Rating";
import { useLoading } from "@/contexts/LoadingContext";
import { useCarouselContents } from "@/hooks/Contents";
import { CarouselContentsArray } from "@/types";
import { formatPrice, shoppingImagePath } from "@/utils";
import { useEffect, useState } from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

type CarouselProductsprops = {
  title?: string;
  color?: string;
  loading?: boolean;
  display?: boolean;
};

type Product = {
  img: string;
  url: string;
  title: string;
  model: string;
  price: string;
  reviews: number;
  rating: number;
  categoryImage?: string;
  generalGrade?: number;
  reviewCount?: number;
};

export function CarouselProducts({ title, color, loading, display }: CarouselProductsprops) {
  const isWide = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: false
  });
  const { setActionIsLoading } = useLoading();

  const [ListProducts, setListProducts] = useState<CarouselContentsArray>(
    null as CarouselContentsArray
  );

  const [CarouselResponse, CarouselError, CarouselLoading] = useCarouselContents();

  useEffect(() => {
    if (CarouselResponse && CarouselError === null) {
      setListProducts(CarouselResponse?.[0]?.contentsArray);
    }
  }, [CarouselResponse]);

  function ArrowProductsPrev(props) {
    const { className, style, onClick } = props;
    return (
      <>
        <Flex
          position={"absolute"}
          left={"-2%"}
          top={"50%"}
          zIndex={1}
          onClick={onClick}
          cursor={"pointer"}
        >
          <Img src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/arrow-slide.svg"} />
        </Flex>
      </>
    );
  }

  function ArrowProductsNext(props) {
    const { className, style, onClick } = props;
    return (
      <>
        <Flex
          position={"absolute"}
          right={"-2%"}
          top={"50%"}
          zIndex={1}
          onClick={onClick}
          cursor={"pointer"}
        >
          <Img
            src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/arrow-slide.svg"}
            transform={"rotate(-180deg)"}
          />
        </Flex>
      </>
    );
  }

  const settings = {
    arrows: true,
    dots: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    centerMode: false,
    nextArrow: <ArrowProductsNext />,
    prevArrow: <ArrowProductsPrev />,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrow: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const renderSlides = () =>
    ListProducts.map((slide, index) => (
      <Flex key={index} minH="435px" w='{["full", "300px"]}'>
        {loading ? (
          <Flex w={["full", "230px"]} h="435px" mr={"10px"}>
            <Skeleton w={"full"} height={"full"} borderRadius={"10px"} />
          </Flex>
        ) : (
          <Flex justify="center">
            <Link
              href={`https://www.pneufree.com.br/linglong/${slide.Url}`}
              _hover={{ textDecoration: "none", opacity: "0.7" }}
              _focus={{ border: "none" }}
              mb="15px"
            >
              <Flex
                position={"relative"}
                w={["full", "230px"]}
                h="435px"
                direction="column"
                alignItems="center"
                bg="white"
                border="1px solid"
                borderColor="gray.100"
                borderRadius={"10px"}
              >
                <Flex w={"90%"} direction="column" align={"center"} justify={"center"}>
                  <Box h={"190px"} marginBottom={"95px"} marginTop={"5px"}>
                    <Image
                      loading="lazy"
                      borderTopRadius={"6px"}
                      src={shoppingImagePath(slide.Img)}
                      alt={slide.Model}
                      width={"205px"}
                      height={"205px"}
                      onError={(e) =>
                        (e.currentTarget.src =
                          "https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/pneu-default.png")
                      }
                    />
                    <Text
                      mt={"5px"}
                      justifyContent={"center"}
                      align={"center"}
                      fontSize={"h2"}
                      color={"ll-gray.300"}
                      fontWeight={"600"}
                      letterSpacing={"-1px"}
                      lineHeight={"28px"}
                    >
                      {slide.Title}
                    </Text>

                    {slide.Model.includes("RUN FLAT") ? (
                      <Flex gap={"5px"} w={"full"} justifyContent={"center"}>
                        <Text
                          align={"center"}
                          fontWeight={"500"}
                          fontSize="text1"
                          color={"ll-blue.main"}
                        >
                          {slide.Model.split(" ", 1)}
                        </Text>
                        <Text
                          align={"center"}
                          fontWeight={"500"}
                          fontSize="text1"
                          color={"ll-red.main"}
                        >
                          {" "}
                          RUN FLAT
                        </Text>
                      </Flex>
                    ) : (
                      <Text
                        align={"center"}
                        fontWeight={"500"}
                        fontSize="text1"
                        color={"ll-blue.main"}
                      >
                        {slide.Model?.replace(slide.Title, "")
                          ?.replace("PNEU", "")
                          .replace("LINGLONG", "")}
                      </Text>
                    )}

                    {/* <Text align={"center"} fontWeight={"500"} fontSize="text1" color={"ll-blue.main"}>
                    {slide.Model?.replace(slide.Title, "")
                      ?.replace("PNEU", "")
                      .replace("LINGLONG", "")}
                  </Text> */}
                  </Box>

                  <Flex></Flex>

                  <Box>
                    <Rating
                      number={false}
                      generalGrade={slide.Ratings}
                      reviewCount={slide.Reviews}
                    />
                  </Box>
                  <Flex mt={"5px"} alignItems={"baseline"}>
                    <Text
                      fontSize={"h1"}
                      color={"ll-blue.main"}
                      fontWeight={"500"}
                      letterSpacing={"-3px"}
                    >
                      {formatPrice(parseFloat(slide.Price))}
                    </Text>
                    <Text ml={"5px"} color={"ll-gray.300"} fontSize={"14px"} fontWeight={"400"}>
                      à vista.
                    </Text>
                  </Flex>

                  <Button variant={"primary-button"} w={"full"} mt={"10px"}>
                    <Text>DETALHES</Text>
                  </Button>
                </Flex>
              </Flex>
            </Link>
          </Flex>
        )}
      </Flex>
    ));

  return (
    <Box
      display={["none", "Flex"]}
      flexDir={"column"}
      h="auto"
      minH="435px"
      maxW={isWide ? "1000px" : "1200"}
      w="full"
      justifyContent="center"
      mb="2.5rem"
    >
      <Center
        color={"ll-blue.main"}
        fontSize={"21px"}
        letterSpacing={"10px"}
        fontWeight={"500"}
        mb={"15px"}
      >
        {title}
      </Center>
      <Slider {...settings}>{ListProducts ? renderSlides() : null}</Slider>
    </Box>
  );
}
